import { render, staticRenderFns } from "./person-juridico.vue?vue&type=template&id=4389516b&"
import script from "./person-juridico.vue?vue&type=script&lang=js&"
export * from "./person-juridico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4389516b')) {
      api.createRecord('4389516b', component.options)
    } else {
      api.reload('4389516b', component.options)
    }
    module.hot.accept("./person-juridico.vue?vue&type=template&id=4389516b&", function () {
      api.rerender('4389516b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/person-juridico.vue"
export default component.exports